import React from 'react';

import { cn } from '@/lib/utils';

type TotemPrimaryButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
    $isSecondaryStyle?: boolean;
    $isDangerStyle?: boolean;
    $minWidth?: string;
};

export const TotemPrimaryButton = React.forwardRef<HTMLButtonElement, TotemPrimaryButtonProps>(
    ({ $isSecondaryStyle, $isDangerStyle, $minWidth, className, style, ...props }, ref) => {
        return (
            <button
                ref={ref}
                className={cn(
                    'inline-flex h-11 shrink-0 cursor-pointer items-center justify-center gap-1.5 rounded-lg px-5 text-[15px] font-extrabold uppercase tracking-[1.5px] transition-all select-none hover:opacity-85 disabled:cursor-default disabled:opacity-50',
                    $isDangerStyle
                        ? 'bg-destructive text-white'
                        : $isSecondaryStyle
                          ? 'bg-zinc-200 text-secondary-foreground hover:bg-zinc-300'
                          : 'bg-primary text-primary-foreground',
                    className,
                )}
                style={{ ...(style || {}), ...($minWidth ? { minWidth: $minWidth } : {}) }}
                {...props}
            />
        );
    },
);
TotemPrimaryButton.displayName = 'TotemPrimaryButton';
